export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b7334a27-b2fb-4fb8-b9b9-88dd349c86ea';
export const MODAL_CLOSE_SEC = 2.5;
